import { t } from '../../../locales';

const subscriptionRoutes = {
	path: 'subscription',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: '',
			name: 'subscription-selection',
			component: () =>
				import('./pages/registration/package-selection.vue'),
			meta: {
				title: t('subscription.selection.page_title'),
			},
		},
		{
			path: 'confirm',
			name: 'subscription-confirm',
			component: () =>
				import('./pages/registration/subscription-confirmation.vue'),
			meta: {
				title: t('subscription.confirmation.page_title'),
			},
		},
		{
			path: 'signup-email',
			name: 'subscription-signup-email',
			component: () =>
				import('./pages/registration/subscription-email-signup.vue'),
			meta: {
				title: t('subscription.email_signup.page_title'),
			},
		},
		{
			path: 'payment-summary',
			name: 'subscription-payment-summary',
			component: () =>
				import('./pages/registration/subscription-payment-summary.vue'),
			meta: {
				title: t('subscription.payment_summary.page_title'),
			},
		},
		{
			path: 'company-info',
			name: 'subscription-company-info',
			component: () =>
				import('./pages/registration/subscription-company-info.vue'),
			meta: {
				title: t('subscription.company_info.page_title'),
			},
		},
		{
			path: 'workspace-loading',
			name: 'subscription-workspace-loading',
			component: () =>
				import('./pages/registration/subscription-workspace-loading.vue'),
			meta: {
				title: t('subscription.workspace_loading.page_title'),
			},
		},
		{
			path: 'payment-success',
			name: 'subscription-payment-success',
			component: () =>
				import('./pages/registration/payment-success.vue'),
			meta: {
				title: t('subscription.payment.success_page_title'),
			},
		},
		{
			path: 'payment-failed',
			name: 'subscription-payment-failed',
			component: () =>
				import('./pages/registration/payment-failed.vue'),
			meta: {
				title: t('subscription.payment.failed_page_title'),
			},
		},
		{
			path: 'renewal-success',
			name: 'subscription-renewal-success',
			component: () =>
				import('./pages/renewal/renewal-success.vue'),
			meta: {
				title: t('subscription.renewal.success_page_title'),
			},
		},
		{
			path: 'renewal-failed',
			name: 'subscription-renewal-failed',
			component: () =>
				import('./pages/renewal/renewal-failed.vue'),
			meta: {
				title: t('subscription.renewal.failed_page_title'),
			},
		},
        {
            path: 'transaction-invoice/:transactionId?',
            name: 'subscription-transaction-invoice',
            component: () =>
                import('./pages/subscription-transaction-invoice.vue'),
            meta: {
                title: 'Subscription Transaction Invoice',
                hideHeader: true,
            },
        }
	],
};

export { subscriptionRoutes };
